"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

var paginationSerializer = function paginationSerializer(data, items) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var inputLimit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var limit = inputLimit ? inputLimit : _constants.PAGE_SIZE;
  var pageCount = Math.ceil(data.count / limit);
  return {
    count: data.count,
    pageSize: limit,
    page: page,
    pageCount: pageCount,
    hasNext: page < pageCount,
    hasPrev: page > 1,
    items: items
  };
};

var _default = paginationSerializer;
exports.default = _default;